<div class="flex justify-center items-center h-dvh md:h-screen">
  <div class="w-full max-w-[512px]" >
    <div class="w-full">
      <img alt="" class="logo !h-20 m-auto" src="logo.png">
    </div>
    <form class="flex flex-col md:flex-row p-4 gap-4 w-full" #loginForm="ngForm" (ngSubmit)="login(loginForm.controls['username'].value, loginForm.controls['password'].value)">
      <div class="flex flex-col gap-4 w-full">
        <wun-input black icon-left class="p-2">
          <wun-profile-icon wunIcon />
          <input required name="username" ngModel placeholder="Username/Email"/>
        </wun-input>
        <wun-input black icon-left>
          <wun-lock-icon wunIcon />
          <input required name="password" ngModel type="password" placeholder="Password" />
        </wun-input>
      </div>
      <div class="flex flex-col">
        <button wunButton primary class="!h-full !px-8">
          {{'login.login' | transloco}}
        </button>
      </div>

    </form>
    <div class="w-full flex justify-center">
      <a routerLink="/auth/password-reset">{{'login.password-forgotten' | transloco}}</a>
    </div>
    <div class="w-full flex justify-center">
      <a [routerLink]="['/']" fragment="signup">{{'login.sign-up' | transloco}}</a>
    </div>

  </div>
</div>
